/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Agent_Receipt_StatusInputs */

const tr_landing_genius_agent_receipt_status = /** @type {(inputs: Landing_Genius_Agent_Receipt_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masraf fişi okundu · tutar girilen bilgiden farklı, kontrol edin.`)
};

const en_landing_genius_agent_receipt_status = /** @type {(inputs: Landing_Genius_Agent_Receipt_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expense receipt read · the amount differs from the entry, please check.`)
};

const de_landing_genius_agent_receipt_status = /** @type {(inputs: Landing_Genius_Agent_Receipt_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesenbeleg gelesen · Betrag weicht von der Eingabe ab, bitte prüfen.`)
};

const ru_landing_genius_agent_receipt_status = /** @type {(inputs: Landing_Genius_Agent_Receipt_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чек расходов прочитан · сумма отличается от введённой, проверьте.`)
};

/**
* | output |
* | --- |
* | "Expense receipt read · the amount differs from the entry, please check." |
*
* @param {Landing_Genius_Agent_Receipt_StatusInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_agent_receipt_status = /** @type {((inputs?: Landing_Genius_Agent_Receipt_StatusInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Agent_Receipt_StatusInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_agent_receipt_status(inputs)
	if (locale === "de") return de_landing_genius_agent_receipt_status(inputs)
	if (locale === "ru") return ru_landing_genius_agent_receipt_status(inputs)
	return tr_landing_genius_agent_receipt_status(inputs)
});